// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","8388":"2fbf9dd2","9594":"97695d0f"}[chunkId] || chunkId) + "." + {"1167":"01d2aefe0f3c9201","2937":"8549aaeb3e4e6c78","5683":"9e2f41a0c600e8e5","5802":"2d2bcacab75c74e0","8388":"959ef03f22b67567","9594":"fd6d3e0ff89b23fc"}[chunkId] + ".js";
};